// eslint-disable-next-line import/no-extraneous-dependencies
import { accordionAnatomy } from '@chakra-ui/anatomy';
import type { ComponentStyleConfig } from '@chakra-ui/react';

export const Accordion: ComponentStyleConfig = {
  parts: accordionAnatomy.keys,
  baseStyle: {
    button: {
      _hover: { bg: 'inherit' },
    },
  },
};
